import { transform } from "lodash";

// Brand Colors
const primaryColor = '#24303B';
const secondaryColor = '#1B69B9';
const accentColor = '#D3D6D8';
const accentSecondaryColor = '#FFFFFF';
const accentSpecialColor = '#1890ff'; 

// Backgrounds
const backgroundBase = '#FFFFFF';
const backgroundSecondary = '#F1F1F1';
const backgroundTertiary = '#E8F4FC';

// Text Colors
const textPrimary = '#24303B';
const textSecondary = '#ffffff';
const textDisabled = '#999999';
const textSpecial = '#1890ff';
const accenttextColor = '#1B69B9';

// Border and Divider
const borderColor = '#E6E4E4';
const borderDisabledColor = '#D9D9D9'; // Disabled border color

// States and Status
const successColor = '#52c41a';
const errorColor = '#ff4d4f';
const warningColor = '#FF0000';
const infoColor = '#1890ff';

// Hover and Active States
const hoverColor = '#e6f7ff';
const activeColor = '#bae7ff';
const selectedColor = '#e6f4ff';

export const standardTokens = {
  borderRadius: 10,
  fontSize: 14,
  colorPrimary: primaryColor,
  colorSecondary: secondaryColor,
  colorBgLayout: backgroundBase,
  colorBgContainer: backgroundSecondary,
  colorText: textPrimary,
  controlHeight: 40,
  fontFamily: `'Open Sans', sans-serif`,
  accentColor: accentColor,
  backgroundTertiary: backgroundTertiary,
  colorTextHeading: secondaryColor,  // Color for all headings (h1–h6)
    fontWeightStrong: 600,        // Strong heading font weight
    lineHeightHeading1: 1.25,     // Custom line heights per level
    lineHeightHeading2: 1.3,
    lineHeightHeading3: 1.35,
    lineHeightHeading4: 1.4,
    lineHeightHeading5: 1.45,
};

export const standardComponents = {
  Typography: {
      colorTextHeading: secondaryColor,   // Ensures title components follow the same color
       titleMarginBottom: 16,         // Margin below headings
      titleFontWeight: 600,          // Heading font weight
    },
    
  Button: {
    colorPrimary: secondaryColor,// primary button background
    colorPrimaryHover: primaryColor,// primary button background
    defaultBg: backgroundBase, // default button background
    defaultColor: accenttextColor, // default button text
    colorError: warningColor, // error button background
    colorErrorHover: primaryColor,         // Hover color
    borderRadius: 3,
    fontWeight: 500,
    fontSize: 14,
    controlHeight: 30,
    paddingBlock: 4,
    paddingInline: 16,
    defaultBorderColor: secondaryColor,
    colorTextDisabled: textDisabled,         // Text color for disabled buttons
    colorBgContainerDisabled: '#dddddd',  // Background color for disabled buttons
    colorBorderDisabled: borderDisabledColor,       // Border color for disabled buttons
    colorBgDisabled: 'transparent', // ⬅️ Set disabled bg to none
    
  },
  Breadcrumb: {
        colorText: secondaryColor,             // breadcrumb text color
        fontSize: 18,                     // font size of breadcrumb items
        linkColor: secondaryColor,             // link color
        linkHoverColor: secondaryColor,        // link color on hover
        separatorColor: borderColor,        // color of the slash (separator)
        lastItemColor: secondaryColor,         // color for the last (active) item
        iconFontSize: 18,                 // size of icon if any in breadcrumb
      },
  Drawer: {
      colorBgElevated: backgroundBase,          // Drawer background
      colorText: textSecondary,                // Default text color
      colorIcon: accentSecondaryColor,                // Close icon color
      colorIconHover: accentSecondaryColor,           // Hover color for close icon
      paddingLG: 24,                       // Large padding
      headerPadding: '10px 14px',          // Header padding
      headerBg: primaryColor,                 // Header background
      colorTextHeading: primaryColor,         // Header title color
      fontWeightStrong: 500,               // Header title weight
      footerPadding: '14px 12px',          // Footer padding
    },
  Table: {
      headerBg: backgroundBase,
      headerColor: textPrimary,
      lineHeight: 2, // ✅ Set your desired line height
      headerFontWeight: 900, // ✅ Bold header text
      headerSplitColor: backgroundBase,
      rowHoverBg: 'transparent', // ⛔ disables hover background color
      rowSelectedBg: selectedColor, // Light blue background for selected row
      rowSelectedHoverBg: '#D0E9FF', // Hover color for selected row
      colorText: textPrimary,
      borderColor: borderColor,
      fontSize: 13,
      padding: 0,
      colorBgContainer: backgroundBase,
      rowExpandedBg: '#FAFCFF',
      headerSortActiveBg: 'transparent',     
      headerSortHoverBg: 'transparent',     
  },
  Pagination: {
      colorBgContainer: backgroundBase, // background of pagination buttons
      colorPrimary: secondaryColor, // selected page border color
      colorPrimaryBorder: secondaryColor,
      colorText: textPrimary, // default text color
      colorTextDisabled: textDisabled, // disabled arrows
      colorTextActive: secondaryColor, // active page number text
      itemActiveBg: selectedColor, // background of active page
      itemInputBg: backgroundBase,
      itemSize: 30,
      fontSize: 13,
      borderRadius: 3,
      borderColorSplit: 'transparent', // remove inner borders
      motionDurationMid: '0.2s',
      controlHeight: 30, 
    },
   
  Select: {
      controlHeight: 32,                // overall height of the select box
      borderRadius: 3,                   // rounded corners
      fontSize: 14,                      // font size
      colorBorder: borderColor,            // normal border color
      colorPrimary: secondaryColor,           // active/focus border & arrow
      colorText: textPrimary,              // text inside the select
      colorTextPlaceholder: '#8C8C8C',   // placeholder text
      colorTextDisabled: textDisabled,      // disabled text
      colorBgContainer: backgroundBase,       // background color
      colorIcon: primaryColor,              // dropdown arrow color (default)
      colorIconHover: secondaryColor,         // arrow color on hover/focus
      boxShadow: '0 0 0 2px rgba(27, 105, 185, 0.15)', // focus ring
      optionSelectedBg: selectedColor,       // selected option background
      optionSelectedColor: secondaryColor,    // selected option text color
      optionActiveBg: '#F5F5F5',         // hovered option background
      
    },
Input: {
      controlHeight: 32,
      borderRadius: 3,
      colorBorder: borderColor, // neutral grey border
      colorText: textPrimary, // input text color
      colorTextPlaceholder: primaryColor, // placeholder color
      colorBgContainer: backgroundBase,
      colorPrimary: secondaryColor, // focus border & icon color
      colorIcon: primaryColor, // search icon color (default state)
      colorIconHover: secondaryColor, // search icon hover color
      activeShadow: '0 0 0 2px rgba(27, 105, 185, 0.15)', // focus shadow
      fontSize: 14,
    },

       Menu: {
        colorItemText: primaryColor,
        colorItemTextHover: secondaryColor,
        colorItemTextSelected: textSecondary,
        colorItemBgHover: 'transparent',
        horizontalItemPadding: '12px 24px',
        itemHeight: 48,
        itemBorderRadius: 3,
        itemMarginInline: 5,
        fontSize: 14,
        fontWeight: 700,
        colorBgContainer: backgroundBase,
        colorPrimary: secondaryColor,
        horizontalLineHeight: 48,
        horizontalMargin: '0 16px 0 0',
        colorSplit: 'transparent',
    },
    DatePicker: {
      controlHeight: 32,            
      borderRadius: 3,
      fontSize: 14,    

      // Input appearance
      colorBorder: borderColor,
      colorText: textPrimary,
      colorTextPlaceholder: '#8C8C8C',
      colorTextDisabled: '#BFBFBF',
      colorBgContainer: backgroundBase,

      // Focus/Active
      colorPrimary: secondaryColor,
      boxShadow: '0 0 0 1px rgba(27, 105, 185, 0.15)',

      // // Reduce internal padding
      // paddingBlock: 2,                  // Vertical padding inside input
      // paddingInline: 8,                 // Horizontal padding inside input

      // Panel calendar styles
      colorBgElevated: backgroundBase,
      colorTextHeading: secondaryColor, // month/year title in calendar
      colorTextDescription: '#A7AEB5', // week day names
      colorBgBase: backgroundBase,

      // Selected date
      colorBgContainerSelected: selectedColor,
      colorTextSelected: secondaryColor,

      // Hover effect
      colorFillSecondary: '#F5F5F5',

      // Calendar panel spacing
      controlItemBgHover: '#F5F5F5',    // Date cell hover background
      cellHeight: 18,                   // Reduced height for date cells
      cellWidth: 30,                    // Reduced width for date cells
      panelGutter: 4,                   // Reduced gap between calendar elements
      withoutTimeCellHeight: 20,        // Date-only cell height
      
      // Header spacing reduction
      headerPadding: '4px',         // Reduce header padding
      headerHeight: 14,                 // Reduce header height
      headerMargin: 0,                  // Remove header margin
      // titleFontSize: 13,                // Smaller title font
     
    },
   Checkbox: {
      // Box styling
      controlInteractiveSize: 15,       // checkbox size
      borderRadiusSM: 3,                // border rounding
      colorBorder: secondaryColor,           // default border
      colorPrimary: secondaryColor,          // checked state border + background
      colorWhite: backgroundBase,            // checkmark color

      // Checked state
      colorPrimaryHover: secondaryColor,     // hover on check
      colorBgContainerChecked: secondaryColor, // ✅ background when checked
      colorText: textPrimary,             // label text

      // Disabled state
      colorBorderDisabled: '#D9D9D9',
      colorTextDisabled: '#A7AEB5',
      colorBgContainerDisabled: '#F5F5F5',
    },

    Modal: {
      // Radius
      borderRadius: 3,

      // Header
      headerBg: secondaryColor, // Blue header background
      titleColor: textSecondary,
      titleFontSize: 16,
      titleFontWeight: 600,
      headerPadding: '12px 24px',

      // Body
      contentBg: backgroundBase,
      bodyPadding: '24px',

      // Footer
      footerBg: backgroundBase,
      footerPadding: '16px 24px',
      footerBorderTop: '1px solid #E6E4E4',

      // Close Button
      closeIconColor: backgroundBase,
      closeBtnSize: 48,

    },

    Dropdown: {
      // Dropdown container background and border
      colorBgContainer: backgroundBase,          // Dropdown panel background
      borderRadius: 3,                      // Corner radius
      borderColor: borderColor,               // Optional: border for custom dropdowns

      // Dropdown item styles
      colorText: textPrimary,                 // Default item text color
      fontSize: 14,                         // Font size for items
      controlHeight: 36,                    // Height for dropdown items
      controlPaddingHorizontal: 12,         // Horizontal padding inside dropdown

      // Hover/active/selected states
      controlItemBgHover: '#f5f5f5',        // Hover background color
      controlItemBgActive: '#e6f7ff',       // Active/focused background
      controlItemBgSelected: '#e6f7ff',     // Background for selected items
      controlItemColorActive: accentSpecialColor,    // Text color when selected/active

      // Disabled item
      colorTextDisabled: textDisabled,         // Text color for disabled item
    },

    Radio: {
      colorPrimary: secondaryColor,         // Circle fill color when selected
      colorText: textPrimary,            // Label color
      colorBorder: borderColor,          // Default unselected border
      dotSize: 6,                      // Size of the inner dot
      buttonSolidCheckedActiveBg: secondaryColor,
      buttonSolidCheckedLabelColor: textSecondary,
    },

    Tooltip: {
      colorBgDefault: secondaryColor,       // Tooltip background color
      colorText: textSecondary,            // Text color
      colorBorder: borderColor,          // Optional: border color
      borderRadius: 3,                 // Rounded corners
      fontSize: 12,                    // Text size
      paddingBlock: 6,                 // Vertical padding
      paddingInline: 12,               // Horizontal padding
    },
     Switch: {
      colorPrimary: secondaryColor,        // Background color when ON
      colorPrimaryHover: secondaryColor,   // Hover color when ON
      colorTextTertiary: secondaryColor,      // Handle color (white)
      handleSize: 16,                 // Optional: adjust handle size
      trackHeight: 22,                // Optional: adjust switch height
      trackMinWidth: 44,              // Optional: adjust switch width
      borderRadius: 20,               // Fully rounded toggle
    },

    Tag: {
      // Background and border
      colorBgContainer: backgroundBase,
      colorBorder: borderColor,
      
      // Text and font
      colorText: textSpecial,          // Primary label (Title:)
      fontWeightStrong: 600,
      fontSize: 14,

      // Padding and size
      paddingInline: 10,
      paddingBlock: 4,
      borderRadius: 6,
      controlHeight: 28,

      // Close icon colors
      colorIcon: warningColor,
      colorIconHover: warningColor,

    },

    Collapse: {
      headerBg: secondaryColor,               // Background of the panel header
      contentBg: backgroundBase,              // Background of the panel content
      colorText: textPrimary,              // Text color for content
      colorTextHeading: textSecondary,       // Header text color
      colorBorder: borderColor,            // Border color
      headerPadding: '12px 16px',        // Padding inside header
      contentPadding: '16px',            // Padding inside content
      headerHeight: 48,                  // Min height of header
      fontSize: 14,                      // Font size for both header and content
      fontSizeIcon: 14,                  // Icon size (expand/collapse arrow)
      borderRadiusLG: 4,                 // Border radius of the panel
      colorIcon: secondaryColor,              // Arrow icon color
      colorBgContainer: '#fff',          // Default container bg
    },

    Tabs: {
      colorText: textPrimary,              // Text color for inactive tabs
      colorPrimary: secondaryColor,           // Active tab indicator (ink bar) & active text
      colorBgContainer: primaryColor,       // Background color of the tabs container
      itemColor: primaryColor,              // Tab label default color
      itemSelectedColor: textSecondary,      // Active tab label color
      itemHoverColor: secondaryColor,         // Hover state text color
      itemActiveColor: secondaryColor,        // Active tab when clicked
      inkBarColor: secondaryColor,            // The underline indicator color
      horizontalItemPadding: '8px 16px', // Tab padding (horizontal tabs)
      verticalItemPadding: '8px 16px',   // Tab padding (vertical tabs)
      fontSize: 14,                      // Font size of tab labels
      lineHeight: 1.5,                   // Line height of tab labels
      cardBg: backgroundBase,                 // Background for card-style tabs
      cardGutter: 3,                     // Spacing between card-style tabs
      cardHeight: 40,                    // Height of each card-style tab
      borderRadiusLG: 3,                 // Rounding on tab edges
    },
};
